import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  CreateSpeakerPayload,
  SpeakerResponse
} from '@utils/types/organization/speaker.ts';

export interface CreateSpeakerResult {
  speaker: SpeakerResponse;
  /** True when the backend inserted a new row (HTTP 201). False when it
   * returned an existing row (HTTP 200) — see api-scriptix create_speaker. */
  created: boolean;
}

const postSpeaker = async (
  payload: CreateSpeakerPayload
): Promise<CreateSpeakerResult> => {
  const { data, status } = await Axios.post<SpeakerResponse>(
    POST_URL().createSpeaker,
    payload
  );
  return { speaker: data, created: status === 201 };
};

export const useCreateSpeaker = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CreateSpeakerResult,
    AxiosError<BaseError>,
    CreateSpeakerPayload
  >(postSpeaker, {
    onSuccess: () => {
      queryClient.invalidateQueries(['speakers']);
    },
    useErrorBoundary: false
  });
};
